/**
 * RBAC Service
 *
 * Talks to the per-tenant RBAC endpoints (Phase 1 backend):
 *  - GET    /rbac/my-access/          effective access map for the caller
 *  - GET    /rbac/catalog/            page catalog (admin)
 *  - GET    /rbac/roles/              roles list (admin)
 *  - POST   /rbac/roles/              create a custom role (admin)
 *  - PATCH  /rbac/roles/:slug/        edit a role (admin)
 *  - DELETE /rbac/roles/:slug/        delete a custom role (admin)
 *  - POST   /rbac/roles/:slug/restore-defaults/  reset a system role (admin)
 */

import apiClient from './api';

export const rbacService = {
  async getMyAccess() {
    const response = await apiClient.get('/rbac/my-access/');
    return response.data; // { access: { [pageKey]: level }, role }
  },
  async getCatalog() {
    const response = await apiClient.get('/rbac/catalog/');
    return response.data;
  },
  async getRoles() {
    const response = await apiClient.get('/rbac/roles/');
    return response.data; // { roles: [...] }
  },
  async createRole(payload) {
    const response = await apiClient.post('/rbac/roles/', payload);
    return response.data;
  },
  async updateRole(slug, payload) {
    const response = await apiClient.patch(`/rbac/roles/${slug}/`, payload);
    return response.data;
  },
  async deleteRole(slug) {
    const response = await apiClient.delete(`/rbac/roles/${slug}/`);
    return response.data;
  },
  async restoreRoleDefaults(slug) {
    const response = await apiClient.post(`/rbac/roles/${slug}/restore-defaults/`);
    return response.data;
  },
};

export default rbacService;
